import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  loading: false
};

const reportProblemStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const reportProblemSuccess = (state, action) => {
  return updateObject(state, { loading: false });
};

const reportProblemFail = (state, action) => {
  return updateObject(state, { loading: false });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REPORT_START:
      return reportProblemStart(state, action);
    case actionTypes.REPORT_SUCCESS:
      return reportProblemSuccess(state, action);
    case actionTypes.REPORT_FAIL:
      return reportProblemFail(state, action);
    default:
      return state;
  }
};

export default reducer;
